module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result04-6ab45b6fc504e57b6c04f77ba1c44ffb.png";